import { Injectable } from "@angular/core";
import { AppConstants } from "src/app-constants";
import { AdditionalRequestDetails, Authentication } from "../internal-models/additional-request-details";
import { ApiRequest } from "../service-models/api-contracts/base/api-request";
import { ApiResponse } from "../service-models/api-contracts/base/api-response";
import { StorageService } from "../services/storage.service";
import { BaseApiClient } from "./base-client/base-api.client";
import { CommonResponseCodeHandler } from "./helpers/common-response-code-handler.helper";
import { StorageCache } from "./helpers/storage-cache.helper";
import { ContactUsSM } from "../service-models/contact-us.s-m";

@Injectable({
    providedIn: 'root'
})
export class ContactUsClient extends BaseApiClient {
    constructor(storageService: StorageService, storageCache: StorageCache,
        commonResponseCodeHandler: CommonResponseCodeHandler) {
        super(storageService, storageCache, commonResponseCodeHandler)


    }
   /**Add a new contact us form */
    AddContactUS = async (contactUsRequest: ApiRequest<ContactUsSM>): Promise<ApiResponse<ContactUsSM>> => {
        let resp = await this.GetResponseAsync<ContactUsSM, ContactUsSM>
            (AppConstants.ApiUrls.CONTACT_US_URL, 'POST', contactUsRequest, 
            new AdditionalRequestDetails<ContactUsSM>(false, Authentication.false));
        return resp;
    }
}